Vendd.Scripts.load(function () {

    var ScriptLoader = function() {

    };

    ScriptLoader.prototype.load = function(url, location) {
      
        return  Q.Promise(function (resolve, reject) {

            var scriptTag = document.createElement('script');

            scriptTag.src = url;
    
            scriptTag.onload = function() {

                resolve();

            };
            scriptTag.onreadystatechange = function() {

                resolve();
                
            };
    
            location.appendChild(scriptTag);
    
        });
    };

    var Vendd = window.Vendd || {};
    Vendd.jsLoader = new ScriptLoader();
    
});